import { showLinkConfirm } from "./popup";
const whitelist = ["gamekee.com"];

export function setupLinkInterceptors() {
  document.addEventListener(
    "click",
    function(event) {
      // 排除在wiki编辑器中
      if (window.location.href.includes("/editor")) return;

      const target = event.target;
      let linkElement = target;

      while (linkElement && linkElement.tagName !== "A") {
        linkElement = linkElement.parentElement;
      }

      if (linkElement && linkElement.tagName === "A") {
        let href = linkElement.getAttribute("href");

        if (href && !href.startsWith("#") && !href.startsWith("javascript:")) {
          // 检查href是否为完整URL（绝对URL）
          // const isCompleteUrl = /^https?:\/\//i.test(href) || ;
          if (/^\/\//i.test(href)) {
            href = "https:" + href;
          }
          if (/^https?:\/\//i.test(href)) {
            // 对于完整URL，检查是否来自同域名或在白名单中
            try {
              const targetHost = new URL(href).hostname; // 目标链接的域名

              // 检查是否在白名单中
              const isWhitelisted = whitelist.some(whitelistedDomain => targetHost.includes(whitelistedDomain));

              // 如果在白名单中，允许访问
              if (isWhitelisted) {
                return; // 跳过后续检查，允许链接正常执行
              } else {
                // 不在白名单中的外部链接
                console.log("外部链接，阻止默认跳转");
                event.preventDefault();

                showLinkConfirm(href).then(shouldContinue => {
                  if (shouldContinue) {
                    window.open(href, "_blank");
                  }
                });
              }
            } catch (e) {
              // 如果URL格式错误无法解析，当作外部链接处理
              console.log("无法解析的链接，阻止默认跳转");
              event.preventDefault();

              showLinkConfirm(href).then(shouldContinue => {
                if (shouldContinue) {
                  window.open(href, "_blank");
                }
              });
            }
          }
        }
      }
    },
    true
  );
}
